<template>
  <div class="record">
    <!-- <div class="game_list" style="position: absolute; top: 0">
      <div class="game_item active">游戏会场11</div>
      <div class="game_item">游戏会场22</div>
    </div> -->
    <div class="record_wrap">
      <div class="record_item flex_between fs_16 bold mb_8">
        <div class="record_ch record_time">时间</div>
        <div class="record_ch record_draw_count">抽奖次数明细</div>
        <div class="record_ch record_draw_result">中奖结果</div>
      </div>
      <div v-if="!list.length && recordFetched" class="record_list mt_24 mb_24 color_grey" style="text-align: center;">
        暂无数据~
      </div>
      <div class="record_list_wrap">
        <div class="record_list fs_12">
          <div
            v-for="it in list"
            :key="it.created_at + it.gift_code"
            class="record_item flex_between mb_6"
          >
            <div class="record_ch record_time">{{ it.created_at }}</div>
            <div class="record_ch record_draw_count">抽奖次数{{ it.type === 1 ? '+' : '-' }}{{ it.num }}</div>
            <div class="record_ch record_draw_result d_flex_col flex_center">
              <div class="mb_4">
                {{ it.register_draw_welfare_reward_name || '--' }}
              </div>
              <van-button
                v-if="it.gift_code && it.type === 2"
                v-clipboard="it.gift_code"
                round
                block
                size="mini"
                color="#E93F11"
                style="width: 68px; padding: 0;"
              >
                复制礼包码
              </van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'vant'
export default {
  components: {
    [Button.name]: Button,
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    recordFetched: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.record {
  height: 100%;
  padding: 40px 12px 24px;
  background-color: #ececec;
  .record_wrap {
    height: 100%;
    overflow: hidden;
    padding: 12px 8px;
    border-radius: 6px;
    background-color: #fff;
  }
  .record_list_wrap {
    height: calc(100% - 24px);
    overflow: auto;
  }
  .record_item {
    .record_ch {
      width: 110px;
      text-align: center;
    }
  }
}
</style>
